export default __webpack_public_path__ + "static/media/charity_bay.de93098d.png";